import api from '@/api';
import { dateFormat, saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;

const contracts = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      filterParams: {
        objectName: '',
        region: '',
        number: '',
        date: '',
        customerName: '',
      },
      filterParamsHistory: [],
      search: '',
      list: {
        contracts: [],
        pageCount: 0,
        page: 0,
      },
      contractDetail: null,
    };
  },

  mutations: {
    setFilterParams(state, params) {
      state.filterParams = params.result;
    },

    setPage(state, page) {
      state.list.page = page;
    },

    setSelectedFilters(state, params) {
      state.selectedFilters = params;
    },

    setSelectedFiltersHistory(state, params) {
      state.selectedFiltersHistory = params;
    },

    clearSelectedFiltersHistory(state) {
      state.selectedFiltersHistory = {};
    },

    setSearch(state, value) {
      state.search = value;
    },

    setList(state, data) {
      state.list = { ...data.result };
    },

    changeLoading(state, status) {
      state.isLoading = status;
    },

    setContractDetail(state, value) {
      state.contractDetail = value;
    },
  },

  actions: {
    async setSearch({ commit, dispatch }, value) {
      commit('setSearch', value);
      commit('setPage', 1);
      await dispatch('loadList');
    },
    async setPage({ commit, dispatch }, page) {
      commit('setPage', page);
      await dispatch('loadList');
    },
    async loadList({
      state, commit, rootState, rootGetters,
    }) {
      commit('changeLoading', true);

      try {
        if (currentTicketListRequest) {
          return;
        }
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']('supplier');

        if (!role && isLoggedIn) {
          return;
        }

        const params = {
          pageSize: 10,
        };

        currentTicketListRequest = api.contracts[role].list(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.search });
        commit('setList', data);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },

    async loadContractDetail({ commit, rootState, rootGetters }, { id }) {
      commit('setContractDetail', null);
      commit('changeLoading', true);

      try {
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']();

        if (!role && isLoggedIn) {
          return;
        }
        const { data } = await api.contracts[role].detail({ id });
        commit('setContractDetail', data.result);
      } catch (e) {
        console.log(e);
        commit('changeLoading', false);
      } finally {
        commit('changeLoading', false);
      }
    },
  },
  getters: {
    contractDetail(state) {
      if (!state.contractDetail) {
        return {
          info: [],
          files: [],
        };
      }

      return {
        info: [
          {
            name: 'Общие сведения',
            items: [
              { value: state.contractDetail.contract.title, name: 'Наименование' },
              { value: state.contractDetail.contract.code, name: 'Код' },
              { value: state.contractDetail.contract.number, name: 'Номер' },
              { value: dateFormat(state.contractDetail.contract.contractDate), name: 'Дата' },
              { value: state.contractDetail.customer.title, name: 'Заказчик' },
              { value: state.contractDetail.partner.title, name: 'Исполнитель' },
            ],
          },
        ],
        files: state.contractDetail.files && state.contractDetail.files.length > 0 ? state.contractDetail.files : [],
      };
    },
  },
};

export default contracts;
